// OrderDetailsSidebar translations
export const orderDetailsSidebarTranslations = {
    en: {
        orderDetails: "Order Details",
        orderID: "Order ID",
        orderNumber: "Order Number",
        date: "Date",
        customer: "Customer",
        paymentMethod: "Payment Method",
        paymentStatus: "Payment Status",
        status: "Status",
        promoCode: "Promo Code",
        orderItems: "Order Items",
        subtotal: "Subtotal",
        shipping: "Shipping",
        tax: "Tax",
        discount: "Discount",
        total: "Total",
        shippingInformation: "Shipping Information",
        phone: "Phone",
        orderNotes: "Order Notes",
        trackOrder: "Track Order",
        viewInvoice: "View Invoice",
        processing: "Processing",
        shipped: "Shipped",
        delivered: "Delivered",
        cancelled: "Cancelled",
        pending: "Pending",
        confirmed: "Confirmed",
        notAvailable: "N/A"
    },
    ar: {
        orderDetails: "تفاصيل الطلب",
        orderID: "رقم الطلب",
        orderNumber: "رقم الطلب",
        date: "التاريخ",
        customer: "العميل",
        paymentMethod: "طريقة الدفع",
        paymentStatus: "حالة الدفع",
        status: "الحالة",
        promoCode: "كود الخصم",
        orderItems: "عناصر الطلب",
        subtotal: "المجموع الفرعي",
        shipping: "الشحن",
        tax: "الضريبة",
        discount: "الخصم",
        total: "المجموع",
        shippingInformation: "معلومات الشحن",
        phone: "الهاتف",
        orderNotes: "ملاحظات الطلب",
        trackOrder: "تتبع الطلب",
        viewInvoice: "عرض الفاتورة",
        processing: "قيد المعالجة",
        shipped: "تم الشحن",
        delivered: "تم التسليم",
        cancelled: "ملغي",
        pending: "في الانتظار",
        confirmed: "مؤكد",
        notAvailable: "غير متوفر"
    }
};

// Helper function to get translated text
export const getTranslation = (language, key) => {
    return orderDetailsSidebarTranslations[language]?.[key] || orderDetailsSidebarTranslations.en[key] || key;
};

// Helper function to get status translation
export const getStatusTranslation = (language, status) => {
    if (!status) return getTranslation(language, 'processing');

    const statusKey = status.toLowerCase();
    const translationKey = statusKey.replace(/_/g, ''); // Remove underscores

    return getTranslation(language, translationKey) || status;
};
